* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
  color: var(--body-text-arrows-400);
  --gap: 10px;
  --icon-width: 18px;
}

.clip-container {
  display: flex;

  gap: var(--gap);

  &__action-btn {
    align-self: flex-end;
  }

  .clip__item {
    word-break: unset;

    &--clip {
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }
}

.placeholder-padding {
  padding-right: calc(var(--gap) + var(--icon-width));
}

:host([hasTextActionButton]) {
  .clip-container {
    display: block;
  }

  #action-button {
    &::part(button) {
      padding: 0;
      margin: var(--spacer) 0;
    }
  }
}

:host([breakWords]) {
  .clip-container {
    .clip__item {
      word-break: break-all;
    }
  }
}
